import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import Section from './Section.js'
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';

class CbuForm extends Component {

    componentWillMount() {
        setTimeout(() => { window.scrollTo(0, 0) }, 2000);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        return (
              <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_cbu" description="Cbu info"/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.verifyCbu)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="cbu" autoComplete="off" component={RenderField} type="number" label="CBU Cuenta Sueldo" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}


CbuForm = reduxForm({
    form: 'CbuForm', // a unique name for this form
})(CbuForm);

CbuForm = withAuthControl(CbuForm);

export default CbuForm;



/** WEBPACK FOOTER **
 ** ./src/components/Cbu.js
 **/